import { AbstractControl, UntypedFormGroup } from '@angular/forms';

import { ApiErrorResponse } from '../interfaces/api-error-response';

export function processErrorResponse(
  form: UntypedFormGroup,
  response: ApiErrorResponse | null | undefined
): void {
  form.markAsTouched();
  if (response && response.errorParameters) {
    Object.entries(response.errorParameters).forEach(([key, message]) => {
      const fieldSelector = key
        .replace('body.', '')
        .replace('[', '.')
        .replace(']', '');
      form.get(fieldSelector)?.setErrors({
        serverError: message,
      });
    });
  }
}

export function getServerErrorForField(
  form: UntypedFormGroup,
  fieldName: string
): any {
  return getServerErrorForControl(form?.get(fieldName));
}

export function getServerErrorForControl(
  control: AbstractControl | undefined | null
): any {
  if (control?.errors) {
    return control?.errors['serverError'];
  }
}

export function getErrorsForField(
  form: UntypedFormGroup,
  fieldName: string
): any {
  return form?.get(fieldName)?.errors;
}

export function logInvalidControls(form: UntypedFormGroup): void {
  console.debug(
    'Form has invalid controls:',
    Object.fromEntries(
      Object.entries(form.controls).filter(([_, ctrl]) => ctrl.invalid)
    )
  );
}
